import * as React from 'react'
import { Text, TextProps, useMedia } from 'tamagui'
import type { DSColor, DSFontSize, DSFontWeight, DSTextVariant } from '../types'
import { fontSizeTokens } from '../../theme/tokens'

type CobuTextProps = TextProps & {
  variant?: DSTextVariant
  color?: DSColor
  fontSize?: DSFontSize | number
  fontWeight?: DSFontWeight
  responsive?: boolean
  selectable?: boolean
}

type VariantStyles = {
  fontSize?: DSFontSize
  fontWeight?: DSFontWeight
  fontFamily?: string
}

const getVariantStyles = (
  variant: DSTextVariant,
  media: ReturnType<typeof useMedia>
): VariantStyles => {
  const fontFamily = '$entrata'
  const styles: Record<DSTextVariant, VariantStyles> = {
    heading: {
      fontSize: '$entrataHeadline',
      fontWeight: 'entrataBold',
      fontFamily,
    },
    subheading: {
      fontSize: '$entrataSubheading',
      fontWeight: 'entrataBold',
      fontFamily,
    },
    body: {
      fontSize: '$entrataBody',
      fontWeight: 'entrataRegular',
      fontFamily,
    },
    caption: {
      fontSize: '$entrataBody',
      fontWeight: 'entrataBold',
      fontFamily,
    },
    label: {
      fontSize: '$entrataBody',
      fontWeight: 'entrataBold',
      fontFamily,
    },
  }
  return styles[variant]
}

export default function CobuText({
  variant = 'body',
  color = '$color',
  fontSize,
  fontWeight,
  responsive = true,
  children,
  selectable = false,
  ...props
}: CobuTextProps) {
  const media = useMedia()
  const variantStyles = responsive ? getVariantStyles(variant as DSTextVariant, media) : {}
  return (
    <Text
      color={color}
      fontSize={fontSize || (variantStyles.fontSize as any)}
      fontWeight={(fontWeight || variantStyles.fontWeight) as any}
      fontFamily={variantStyles.fontFamily as any}
      userSelect={selectable ? 'text' : 'none'}
      {...props}
    >
      {children}
    </Text>
  )
}


